import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
const getComponentFilterOptionsConfigValidator = (keys) => {
    const fieldValidators = keys.reduce((validators, key) => {
        validators[key] = Validator.optional(Validator.array());
        return validators;
    }, {});
    return Validator.optional(Validator.object(fieldValidators));
};
export const getComponentFilterConfigValidator = (keys) => {
    return Validator.optional(Validator.object({
        filterId: nonEmptyStringValidator,
        options: getComponentFilterOptionsConfigValidator(keys)
    }));
};
